import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useAriaLiveContext from "./useAriaLiveContext";
import AriaLiveMessages from "./AriaLiveMessages";

const propTypes = {
	numberAssertiveDivs: PropTypes.number,
	numberPoliteDivs: PropTypes.number,
};
const defaultProps = {
	numberAssertiveDivs: 2,
	numberPoliteDivs: 2,
};

// questions:
// * should it ever remove old messages eventually?
// * how many messages can be added to a div at a time? how long in between adds?

const setupDefaultLists = numberOfLists => Array.from({ length: numberOfLists }).map(() => []);

const AriaLive = ({ numberAssertiveDivs, numberPoliteDivs }) => {
	const { ariaLivePoliteMessages, ariaLiveAssertiveMessages } = useAriaLiveContext();

	return (
		<div className="visually-hidden" id="react-aria-live-messages">
			<AriaLiveMessages
				ariaLive="polite"
				messages={ariaLivePoliteMessages}
				numberDivs={numberPoliteDivs}
			/>
			<AriaLiveMessages
				ariaLive="assertive"
				messages={ariaLiveAssertiveMessages}
				numberDivs={numberAssertiveDivs}
			/>
		</div>
	);
};

AriaLive.propTypes = propTypes;
AriaLive.defaultProps = defaultProps;

export default AriaLive;